<script lang="ts">
	// export let data;

	// async function roll() {
	// 	const response = await fetch('https://jsonplaceholder.typicode.com/posts');
	// 	data = await response.json();
	// 	console.log(data);
	// }
</script>

<svelte:head>
	<title>O kancelarii</title>
	<meta name="description" content="Kim jesteśmy i co robimy czyli kilka słów o naszej kancelarii." />
</svelte:head>

